<script setup>
import {computed} from 'vue'
import {useModalsStore} from '@/stores/modals'
import {useViewStore} from '@/stores/view'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    viewId: String,
})

const appStore = useAppStore()
const viewStore = useViewStore(props.viewId)
const modalsStore = useModalsStore()

const tableName = computed(() => viewStore.tableName)
const show = computed(() => tableName.value === 'files' && appStore.betaMode)

const openModal = () => {
    modalsStore.show({
        componentName: 'BulkUploadModal',
        obj: {
            modalTitle: 'Bulk upload',
            onComplete: () => {
                // let viewId = appStore.mainViewId
                // const mainViewStore = useViewStore(viewId)
                // mainViewStore.scheduleLoad()
            }
        }
    })
}
</script>

<template>
    <button v-if="show" class="d-flex align-items-center" type="button" @click="openModal">
        <i class="me-2 bi-arrow-up-circle-fill"/>
        Bulk upload
        <small class="ms-1 badge text-bg-warning">beta</small>
    </button>
</template>